class Dispatcher {
    listeners = null

    constructor() {
      this.listeners = {};
    }

    addEventListener(type, callback) {
      if (!(type in this.listeners)) {
        this.listeners[type] = [];
      }
      this.listeners[type].push(callback);
    }

    removeEventListener(type, callback) {
      if (!(type in this.listeners)) {
        return;
      }
      const stack = this.listeners[type];
      for (let i = 0, l = stack.length; i < l; i += 1) {
        if (stack[i] === callback) {
          stack.splice(i, 1);
          return;
        }
      }
    }

    dispatchEvent(event) {
      if (!(event.type in this.listeners)) {
        return true;
      }
      const stack = this.listeners[event.type].slice();

      let result;
      for (let i = 0, l = stack.length; i < l; i += 1) {
        result = stack[i].call(this, ...event.payload);
        if (event.halt && result === false) break;
      }
      return result;
    }

    listen(type, callback) {
      this.addEventListener(type, callback);
    }

    forget(type, callback) {
      this.removeEventListener(type, callback);
    }

    dispatch(type, payload = null, halt = false) {
      this.dispatchEvent({ type, payload: payload ? [payload] : [], halt });
    }

    fire(type, payload = null, halt = false) {
      this.dispatch(type, payload, halt);
    }

    until(type, payload = null) {
      this.dispatch(type, payload, true);
    }
}

export default Dispatcher;
